import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { listTransfer, transferState, deleteTransfer, resetDeletedTransfer } from '../transferSlice';


interface Props {
    children?: React.ReactNode;
    item?: any;
}
const ConfirmDeleteTransferModal = (props: Props) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const dispatch = useAppDispatch();
    const confirmAction = () => {
        dispatch(deleteTransfer({ transferId: props?.item?.id }))
    };

    const { deletedTransfer, list } = useAppSelector(transferState);

    useEffect(() => {
        if (deletedTransfer.isSuccess || deletedTransfer.isError) {
            dispatch(resetDeletedTransfer());
            dispatch(listTransfer({ start: list.current === 'firstPage' ? undefined : list.current }));
            handleClose();
        }
    }, [deletedTransfer, list, dispatch]);

    return (
        <>
            <div onClick={handleShow}>{props?.children}</div>
            <Modal centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Transfer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {deletedTransfer.isLoading && < SmashSpinner />}
                    {!deletedTransfer.isLoading &&
                        <div>
                            Are you sure to delete the following transfer ?
                            <p>
                                <code>{props?.item?.id}</code>
                            </p>
                        </div>}

                </Modal.Body>
                {!deletedTransfer.isLoading && <Modal.Footer>
                    <Button onClick={handleClose} variant='light'>No</Button>
                    <Button onClick={confirmAction}>Yes</Button>
                </Modal.Footer>}
            </Modal>
        </>
    )
}

export default ConfirmDeleteTransferModal